import "./LocalAndConsumerServices.module.css";
import Header from "@/reusable_sections/Header";
import HubHero from "./sections/HubHero";
import LocalGuidance from "./sections/LocalGuidance";
import RelatedServices from "./sections/RelatedServices";
import Footer from "@/reusable_sections/Footer";
export default function LocalAndConsumerServicesPage() {
  return <div>
      <Header />
      <HubHero />
      <LocalGuidance />
      <RelatedServices />
      <Footer />
    </div>;
}